
import apiClient from './client'


export interface Tag {
    id: number;
    tag_user_id: number;
    tag_name: string;
    tag_description: string;
    tag_group_id: number;
    language_code: string;
    color?: string;
    icon?: string;
}

export interface UserTags {
    // Define the structure of user tags here
    id: number;
    tag_name: string;
    tag_description: string;
    tag_group_id: number;
    language_code: string;
    color?: string;
    icon?: string;
}

export interface TagGroup {
    id: number;
    name: string;
    description: string;
}
export const tagService = {
    addTag: async (userId: number, tags: Tag, learningLanguage?: string) => {
        try {
            const tagData = {
                ...tags,
                language_code: learningLanguage || tags.language_code
            };
            const response = await apiClient.post(`/api/v1/tags`, tagData);
            return response.data;
        } catch (error) {
            console.error(error);
            throw new Error('Failed to add tags');
        }
    },

    getUserTags: async (language?: string) => {
        try {
            const url = language ? `/api/v1/tags?language=${language}` : `/api/v1/tags`;
            const response = await apiClient.get(url);
            return response.data;
        } catch (error) {
            throw new Error('Failed to fetch user tags');
        }
    },
    getTagGroups: async () => {
        try {
            const response = await apiClient.get(`/api/v1/tag-groups`);
            return response.data;
        } catch (error) {
            throw new Error('Failed to fetch user tags');
        }
    },
    getUserTagsById: async (userId: number) => {
        try {
            const response = await apiClient.get(`/api/v1/tags?user_id=${userId}`);
            return response.data;
        } catch (error) {
            throw new Error('Failed to fetch user tags');
        }
    },
    updateTag: async (id: number, tags: Tag, learningLanguage?: string) => {
        try {
            const tagData = {
                ...tags,
                language_code: learningLanguage || tags.language_code
            };
            const response = await apiClient.put(`/api/v1/tags/${id}`, tagData);
            return response.data;
        } catch (error) {
            console.error(error);
            throw new Error('Failed to update tags');
        }
    },

    deleteTag: async (id: number) => {
        try {
            const response = await apiClient.delete(`/api/v1/tags/${id}`);
            return response.data;
        } catch (error) {
            console.error(error);
            throw new Error('Failed to delete tag');
        }
    },
};